import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { client } from '..';
import { GET_ALL_HANDBOOK_ACCESS, UPSERT_HANDBOOK_ACCESS } from "../Queries/handBook";

const initialState = {
  loadingAll: false,
  saving: false,
  error: null,

  allHandbookAccess: [],   // ← array from getAllHandbookAccess (organized by handbook)
};

export const fetchAllHandbookAccess = createAsyncThunk(
  "handbookAccess/fetchAll",
  async ({ includeInactive = false }, { rejectWithValue }) => {
    try {
      const { data } = await client.query({
        query: GET_ALL_HANDBOOK_ACCESS,
        variables: { includeInactive },
        fetchPolicy: "network-only",
      });

      return data.getAllHandbookAccess;
    } catch (err) {
      return rejectWithValue(err.message || "Fetch failed");
    }
  }
);

export const upsertHandbookAccess = createAsyncThunk(
  "handbookAccess/upsert",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: UPSERT_HANDBOOK_ACCESS,
        variables: {
          handbookId: payload.handbookId,
          handbookName: payload.handbookName,
          employeesToAdd: payload.employeesToAdd || [],
          employeesToRemove: payload.employeesToRemove || [],
          changedBy: payload.changedBy,
          note: payload.note,
        },
        fetchPolicy: "no-cache",
      });

      return data.upsertHandbookAccess;
    } catch (err) {
      return rejectWithValue(err.message || "Save failed");
    }
  }
);

const handbookAccessSlice = createSlice({
  name: "handbookAccess",
  initialState,
  reducers: {
    resetHandbookAccessState: () => initialState,
  },
  extraReducers: (builder) => {
    builder

      /* =======================
         FETCH ALL HANDBOOK ACCESS
         ======================= */
      .addCase(fetchAllHandbookAccess.pending, (state) => {
        state.loadingAll = true;
        state.error = null;
      })
      .addCase(fetchAllHandbookAccess.fulfilled, (state, action) => {
        state.loadingAll = false;
        state.allHandbookAccess = action.payload || [];
      })
      .addCase(fetchAllHandbookAccess.rejected, (state, action) => {
        state.loadingAll = false;
        state.error = action.payload || "Failed to load handbook access";
      })

      /* =======================
         UPSERT HANDBOOK ACCESS
         ======================= */
      .addCase(upsertHandbookAccess.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(upsertHandbookAccess.fulfilled, (state, action) => {
        state.saving = false;

        const updated = action.payload;
        if (!updated?.handbookId) return;

        const index = state.allHandbookAccess.findIndex(
          (h) => h.handbookId === updated.handbookId
        );

        if (index !== -1) {
          // UPDATE existing handbook record
          state.allHandbookAccess[index] = updated;
        } else {
          // ADD new handbook record
          state.allHandbookAccess.unshift(updated);
        }
      })
      .addCase(upsertHandbookAccess.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload || "Failed to save handbook access";
      });
  },
});

export const {
  resetHandbookAccessState,
} = handbookAccessSlice.actions;

export default handbookAccessSlice.reducer;